import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function ProfitMaximizerUpsell() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Check if user has dismissed the upsell
    const isDismissed = localStorage.getItem('awc_profit_maximizer_dismissed');
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);
  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('awc_profit_maximizer_dismissed', 'true');
  };
  return <AnimatePresence data-id="element-432">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="relative mb-8 overflow-hidden rounded-lg border border-[#2a2a2a] border-l-[4px] border-l-[#F5C842] bg-[#0d0d0d] p-6 md:p-8" data-id="element-433">
          {/* Dismiss Button */}
          <button onClick={handleDismiss} className="absolute right-4 top-4 text-[#555] transition-colors hover:text-white" aria-label="Cerrar oferta" data-id="element-434">
            <X className="h-5 w-5" data-id="element-435" />
          </button>

          {/* Badge */}
          <div className="mb-4 inline-block rounded bg-[#F5C842]/10 px-3 py-1 font-heading text-[10px] font-black tracking-[1px] text-[#F5C842] uppercase" data-id="element-436">
            🔥 30% OFF — EXCLUSIVO PARA MIEMBROS
          </div>

          {/* Header */}
          <div className="mb-6" data-id="element-437">
            <h3 className="font-heading text-[22px] font-black leading-tight text-white md:text-[26px]" data-id="element-438">
              Profit Maximizer
            </h3>
            <p className="mt-1 text-[13px] text-[#999]" data-id="element-439">
              Maximiza tus ganancias desde el primer cliente
            </p>
          </div>

          {/* Included Items */}
          <div className="mb-6 space-y-3" data-id="element-440">
            <div className="flex items-start gap-3 rounded bg-black/50 p-3" data-id="element-441">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#F5C842]" data-id="element-442" />
              <div data-id="element-443">
                <div className="font-heading text-[13px] font-bold text-white" data-id="element-444">
                  Kit del Primer Cliente
                </div>
                <div className="text-[12px] text-[#777]" data-id="element-445">
                  5 Guiones Copiar y Pegar por Nicho (Valor $17)
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded bg-black/50 p-3" data-id="element-446">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#F5C842]" data-id="element-447" />
              <div data-id="element-448">
                <div className="font-heading text-[13px] font-bold text-white" data-id="element-449">
                  La Máquina de Ingresos Recurrentes
                </div>
                <div className="text-[12px] text-[#777]" data-id="element-450">
                  Convierte cada cliente en $99/mes (Valor $37)
                </div>
              </div>
            </div>
          </div>

          {/* Pricing & CTA */}
          <div className="flex flex-col items-center justify-between gap-4 border-t border-[#2a2a2a] pt-6 md:flex-row md:gap-6" data-id="element-451">
            <div className="text-center md:text-left" data-id="element-452">
              <div className="flex items-center justify-center gap-2 md:justify-start" data-id="element-453">
                <span className="text-[16px] text-[#555] line-through" data-id="element-454">
                  $54
                </span>
                <span className="rounded bg-[#F5C842] px-2 py-0.5 font-heading text-[10px] font-black text-black" data-id="element-455">
                  AHORRA 30%
                </span>
              </div>
              <div className="font-heading text-[28px] font-black text-[#F5C842]" data-id="element-456">
                $37
              </div>
            </div>

            <a href="https://offer.aiwebcloser.com/cart/48205306134776:1" target="_blank" rel="noopener noreferrer" className="w-full rounded bg-[#F5C842] px-6 py-[18px] text-center font-heading text-[14px] font-black text-black transition-transform hover:-translate-y-0.5 md:w-auto" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)',
          border: '2px solid #F5C842'
        }} data-id="element-457">
              🚀 Obtener Profit Maximizer — 30% OFF →
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}